import React, { useState, useMemo } from 'react';
import {
  Form, Modal, Label,
} from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { ThemedButton } from 'components/lib/UI';
import util from 'utils/utils';

import Tag, { TagContainer } from 'components/lib/Tag';

export const TagView = ({
  tags, hideView, noMargin, children, ...tagProps
}) => (hideView ? children : <TagContainer noMargin={noMargin}>
  {tags ? tags.map((t, idx) => <Tag
    tag={t}
    key={idx}
    {...tagProps}
  />) : null}
  {children}
</TagContainer>);

const TagChooserContent = ({
  tags, allTags, removeTag, addTag, showCount,
}) => {
  const tagIds = useMemo(() => tags.map((c) => c._id), [tags]);
  const { selectedTags = [], availableTags = [] } = allTags.reduce((p, c) => {
    p.selectedTags = p.selectedTags || [];
    p.availableTags = p.availableTags || [];

    if (tagIds.includes(c._id)) {
      p.selectedTags.push(c);
    } else {
      p.availableTags.push(c);
    }
    return p;
  }, {});
  const tagsRemaining = tags?.length ? (4 - tags.length) : 4;
  return (
    <Form>
      <h5>Selected tags</h5>
      <TagView
        tags={selectedTags}
        showCount={showCount}
        noRedirect
        onClick={(t) => { removeTag(t); }}
        onRemove={(t) => { removeTag(t); }}
      />
      {tags?.length > 0 && <Label size='tiny' basic>{util.pluralise(tagsRemaining, 'tag', 'tags')} remaining</Label>}
      <h5>All usable tags</h5>
      <p>Clicking a tag will add it to the selected tags</p>
      <TagView
        tags={availableTags}
        noRedirect
        showCount={showCount}
        onClick={(t) => {
          if (!tagIds.includes(t._id)) {
            addTag(t);
          }
        }}
      />
    </Form>
  );
};

const TagModalChooser = ({
  tags = [], availableTags = [], removeTag, addTag, user, trigger, noRedirect, canEdit = true, showCount = true, viewCanRemove, onStateChange, hideView = false, noMargin, isChallenge,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const triggerElement = useMemo(() => (trigger ? React.cloneElement(trigger, {
    onClick: () => {
      onStateChange && onStateChange(true);
      setModalOpen(true);
    },
  }) : null), [trigger, onStateChange]);
  const allTags = availableTags || [];

  if (!canEdit) {
    return <TagView tags={tags} />;
  }

  if (!trigger) {
    return <TagChooserContent tags={tags} allTags={allTags} removeTag={removeTag} addTag={addTag} user={user} showCount={showCount} />;
  }

  if (availableTags.length === 0) {
    return null;
  }
  return (
    <>
      <TagView tags={tags} noRedirect={noRedirect} onRemove={viewCanRemove ? removeTag : null} hideView={hideView} noMargin={noMargin}>
        {triggerElement}
      </TagView>

      <Modal open={modalOpen} closeOnDimmerClick onClose={() => {
        onStateChange && onStateChange(false);
        setModalOpen(false);
      }}>
        <Modal.Header>Tags</Modal.Header>
        <Modal.Content>
          <p>Please select the tags which best categorise your {isChallenge ? 'challenge' : 'idea'}. The maximum number of tags you can use is 4.</p>
          <TagChooserContent tags={tags} allTags={allTags} removeTag={removeTag} addTag={addTag} user={user} showCount={showCount} />
        </Modal.Content>
        <Modal.Actions>
          <ThemedButton onClick={() => {
            onStateChange && onStateChange(false);
            setModalOpen(false);
          }}>Done</ThemedButton>
        </Modal.Actions>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => ({ user: state.user });

export default withTranslation()(connect(mapStateToProps)(TagModalChooser));
